module.exports = __webpack_public_path__ + "static/img/noCart.49e0be58.png";